import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { DefaultWrapper } from '../../components/Layout/DefaultWrapper';
import MenuOpener from '../../components/MenuOpener';
import Footer from '../../components/Layout/Footer';

// Screens
import FeatureScreen from './screens/Feature';
import MainContactScreen from './screens/MainContact';
import JoinTheTeamScreen from './screens/JoinTheTeam';

const Contact = () => (
  <DefaultWrapper>
    {/* menu */}
    <MenuOpener className="menu-opener" />
    <FeatureScreen />
    <MainContactScreen />
    <JoinTheTeamScreen />
    <Footer />
  </DefaultWrapper>
);

export default connect()(Contact);



// WEBPACK FOOTER //
// ./src/pages/Contact/index.jsx